import { apiRequest } from '@common/api/utils';

const LSQ_TRACK_ELES_CLASS = 'lsq-track-element';

export async function trackLsqEvents(data) {
  try {
    await apiRequest(
      'POST',
      '/api/v3/lsq-events/send-activity/',
      { ...data, account_name: 'school_of_business' },
    );
  } catch (error) {
    // track this error over somewhere like mixpanel
  }
}

export const initialize = () => {
  const lsqTrackEles = document.querySelectorAll(`.${LSQ_TRACK_ELES_CLASS}`);

  const handleEleClick = (ele) => {
    ele.removeEventListener('click', () => handleEleClick(ele));
    const activityName = ele.getAttribute('data-lsq-label');
    if (!activityName) return;

    const activityDescription = ele.getAttribute('data-lsq-description');

    trackLsqEvents({
      activity_name: activityName,
      description: activityDescription,
      check_existence: false,
    });
  };

  lsqTrackEles.forEach(ele => {
    ele.addEventListener('click', () => handleEleClick(ele), { once: true });
  });
};

export default {
  initialize,
  trackLsqEvents,
};
